export const OCCASIONS = ['Anniversary', 'Birthday', 'Business', 'Casual'];